import styled from 'styled-components';

export const TimeOffer = styled.p`
  color: ${({ theme }) => theme.white};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.green};
  margin: 0;
  margin-bottom: 13px;
  font-size: 12px;
  padding: 6px 8px 4px;
  font-weight: bold;
  display: inline-block;
`;

export const Header = styled.h2`
  font-size: 20px;
  margin: 0;
  margin-bottom: 5px;
`;

export const SubHeading = styled.p`
  margin: 0;
`;

export const CloseBtn = styled.button`
  border: none;
  background-color: none;
  font-size: 12px;
  line-height: 18px;
`;

export const UpgradeContainer = styled.div`
  width: 300px;
  margin-top: -32px;

  @media(min-width: 768px) {
    width: 690px;
    overflow:visible;
  }

  .swiper-container { 
    height: 540px;
    overflow: visible;

    @media(max-width: 768px) {
      padding-top: 10px;
      height: auto;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    background-color: ${({ theme }) => theme.white };
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-image: none;
    background: #FFFFFF;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.24);
    border-radius: 28px;
    top: 42%;
    &:after {
      position: absolute;
      top: 55%;
      left: 55%;
      transform: translate(-50%, -50%);
      content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDggMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDFMNyA2TDEgMTFWMVoiIGZpbGw9IiMxRUI2RkYiIHN0cm9rZT0iIzFFQjZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=);
    }
  }

  .noThanks { 
    cursor: pointer;
    font-size: 12px;
  }

  .swiper-button-prev {
    &:after {
      transform-origin: left;
      transform: translate(5%,-70%) rotate(180deg) !important;
    }
  }
`;

export const UpgradeCardWrapper = styled.div`
    width: 214px;

    @media(min-width: 768px) {
      width: 410px;
      height: 420px;
    }

    &:first-child {
      margin-left: 15px;

      @media(min-width: 768px) {
        margin-left: 55px;
      }
    }
`;

export const UpgradeCardSingle = styled.div`
      width: 214px;
      width: 90%;
      margin: 0 auto;
      border-radius: 28px;
      article{ 
        overflow: visible;
      }

      &:first-child {
      margin-left: 15px;

      @media(min-width: 768px) {
          margin-left: 55px;
      }
    }
`;

